<template>
    <v-app>
        <template v-if="!loggedUser">
            <v-content>
                <!-- Provides the application the proper gutter -->
                <v-container fluid>
                    <!-- If using vue-router -->
                    <router-view></router-view>

                </v-container>
            </v-content>
        </template>


        <template v-else>

            <main-drawer></main-drawer>
            <v-app-bar app>
                <v-app-bar-nav-icon class="d-sm-flex d-md-none"
                                    @click="$store.commit('SET_DRAWER', true)"></v-app-bar-nav-icon>

                <portal-target name="toolbarMenuContent" class="d-flex align-center w-100"></portal-target>

            </v-app-bar>

            <!-- Sizes your content based upon application components -->
            <v-content>
                <!-- Provides the application the proper gutter -->
                <v-container fluid>
                    <!-- If using vue-router -->
                    <router-view></router-view>

                </v-container>
                <div class="col-12 text-center" id="footer">© 2020 Yobee - Tutti i diritti riservati | <a
                        href="https://www.yobee.it/cookie-policy/" target="_blank">Cookie & Privacy Policy</a></div>
            </v-content>
        </template>

    </v-app>

</template>

<script>
  import MainDrawer from './components/drawers/MainDrawer'

  export default {
    name: 'App',
    components: {
      MainDrawer,
    },
    computed: {
      loggedUser () {
        let  auth =this.$store.getters.auth
        return !!(localStorage.getItem('auth') && !!auth )
      }
    },
    mounted () {
      const tooltipsState = localStorage.getItem("tooltips-state")
      if(tooltipsState){
       this.$store.commit("loadTooltips",tooltipsState)
      }
    }
  }
</script>
